/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Upgradefailed1Inputs */

const zh_subscription_upgradefailed1 = /** @type {(inputs: Subscription_Upgradefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级失败`)
};

const en_subscription_upgradefailed1 = /** @type {(inputs: Subscription_Upgradefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade failed`)
};

const es_subscription_upgradefailed1 = /** @type {(inputs: Subscription_Upgradefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar`)
};

/**
* | output |
* | --- |
* | "Upgrade failed" |
*
* @param {Subscription_Upgradefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_upgradefailed1 = /** @type {((inputs?: Subscription_Upgradefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Upgradefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_upgradefailed1(inputs)
	if (locale === "en") return en_subscription_upgradefailed1(inputs)
	return es_subscription_upgradefailed1(inputs)
});
export { subscription_upgradefailed1 as "subscription_upgradeFailed" }